<template>
  <div :class="$style.personal">
    <div :class="$style.main" v-show="mainShow">
      <img :src="`${$cdnLink}/suspend/tongyong/guanbi.png`" alt="" @click="$emit('close')" :class="$style.close" />
      <p :class="$style.account">账号：{{ userState.username }}</p>
      <div :class="$style.mainContent">
        <div :class="$style.asSeat">
          <img :src="item.entrance_icon" alt="" v-for="item in personalAdSeat" :key="item.id" @click="handleAdClick(item)" />
        </div>
        <Banner v-if="personalAdBanner.length" @click="handleBannerClick" :imgArr="personalAdBanner"></Banner>
        <!-- <img :src="boxAdBanner.entrance_icon" alt="" v-if="boxAdBanner && boxAdBanner.status == 1" @click="redirectBoxAdPage" :class="$style.actBack" /> -->
        <!-- <img
          :src="activity_show_info.banner_background"
          alt=""
          v-if="activity_show_info.activity === 1"
          @click="showActivity"
          :class="$style.actBack"
        /> -->
        <div :class="$style.cell" @click="showComponent('voucher')" v-if="voucherShow">
          <span :class="[voucherHint ? $style.hint : '']">我的卡券</span>
        </div>
        <div :class="$style.cell" @click="showComponent('changePwd')">修改密码</div>
        <div :class="$style.cell" @click="showComponent('bindPhone')">
          <span :class="`${userState.tel_status == 0 ? $style.hint : ''}`">手机号码</span>
          <span :class="[userState.tel_status == 0 ? $style.red : '']">{{
            userState.tel_status == 0 ? '未绑定手机，安全性低' : isV2Sdk ? '已绑定，可换绑' : '已绑定，可解绑'
          }}</span>
        </div>
        <div :class="$style.cell" v-if="bindGiftInfo" @click="showComponent('bindGift')">
          <span>绑定有礼</span>
          <span>点击领取</span>
        </div>
        <div :class="$style.cell" @click="showComponent('vip')" v-if="is_vip == 1">VIP</div>
        <div :class="$style.cell" @click="showComponent('logout')">切换帐号</div>
        <div :class="$style.cell" @click="showComponent('writeOff')" v-if="isIos">账号注销</div>
        <div :class="$style.cell" @click="showComponent('argument')">用户隐私协议</div>
         <div :class="$style.cell" @click="showComponent('kf')">人工客服</div>
      </div>
    </div>
    <BoxDownload v-if="boxDownLoadShow" @close="handleCloseBoxDownload" :type="boxDownloadType"></BoxDownLoad>
    <component
      :is="componentId"
      v-if="componentShow"
      :class="$style.component"
      isSuspend="true"
      @close="close"
      @closePage="$emit('close')"
      @bindPhone="bindPhone"
    ></component>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChangePassword from './ChangePassword.vue';
import BindPhone from './BindPhone.vue';
import BindPhoneV2 from './BindPhoneV2.vue';
import BindGift from './BindGift.vue';
import ChangePwdV2 from './ChangePwdV2.vue';
import Argument from '@/components/login/Argument';
import Banner from '@/components/common/Slide.vue';
import BoxDownload from '../common/boxDownload.vue';
import Voucher from './Voucher.vue'

import Vip from './Vip.vue';
import Logout from './Logout.vue';
import WriteOffWindow from './WriteOffWindow.vue';
import { eventTrack } from '@/api/user';
import { boxBannerValid } from '@/api/suspend'
import { boxSkipAnyPage2Sdk, skipWXBox2Sdk, sendSyDiyIntent, gameOpenDownloads, downloadProgress2H5 } from '@/bridge/AppJsBridge';
import { boxDownloadUrl, wxBoxDownloadUrl } from '@/config';
import { generActLink } from '@/libs/business/box';
import { isAndroid } from '@/libs/utils.js';
import { buryReportV2 } from '@/libs/business/account';
import { redirBoxNewVersion } from '@/libs/business/version'

export default {
  name: '',
  data() {
    return {
      componentShow: false,
      mainShow: true,
      gameType: '',
      isIos: !isAndroid(),
      boxDownloadType: 'wx',
      isV2Sdk: false, // 是否是v2登录模式
      currentAdId: '',
      voucherShow: false,
      voucherHint: false
    };
  },
  mounted() {
    this.isV2Sdk = localStorage.getItem('isV2Sdk');

    this.$store.dispatch('suspend/getGiftInfo');
    this.$store.dispatch('suspend/getPersonalBanner');
    this.getVoucher();
    // 盒子广告位接口判断
    this.gameType = this.$getStorage('game_type');
    if (this.gameType === 'boxGame' || this.gameType === 'wxBoxGame') {
      this.$store.dispatch('activity/getBoxAdBanner');
      downloadProgress2H5((data) => {
        this.$toast({
          message: data,
          position: 'bottom',
        });
      });
    }
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
      is_vip: (state) => state.user.is_vip,
      official_status: (state) => state.activity.official_status,
      appkey: (state) => state.user.appkey,
      bindGiftInfo: (state) => state.suspend.bindGift,
      boxAdBanner: (state) => state.activity.box_ad_banner,
      personalAdSeat: (state) => state.suspend.personalAdSeat,
      personalAdBanner: (state) => state.suspend.personalAdBanner,
      boxDownLoadShow: (state) => state.suspend.boxDownLoadShow,
    }),
  },
  components: {
    Banner,
    BoxDownload
  },
  methods: {
    close() {
      this.componentShow = false;
      this.mainShow = true;
    },
    showComponent(type) {
      switch (type) {
        case 'changePwd':
          buryReportV2('SDK_MENU_PERSONAL_PASSWORD', {  menu_name: '修改密码'});
          this.mainShow = false;
          this.componentId = this.isV2Sdk ? ChangePwdV2 : ChangePassword;
          break;
        case 'bindPhone':
          buryReportV2('SDK_MENU_PERSONAL_MOBILE', {  menu_name: '绑定/解绑手机'});
          this.mainShow = false;
          this.componentId = this.isV2Sdk ? BindPhoneV2 : BindPhone;
          break;
        case 'vip':
          this.componentId = Vip;
          break;
        case 'logout':
          buryReportV2('SDK_MENU_PERSONAL_SWITCH', {  menu_name: '切换账号'});
          this.componentId = Logout;
          break;
        case 'bindGift':
          buryReportV2('SDK_MENU_PERSONAL_BIND_GIFT', {  menu_name: '绑定有礼'});
          this.componentId = BindGift;
          break;
        case 'writeOff':
          this.componentId = WriteOffWindow;
          break;
        case 'argument':
          this.$store.commit('user/CHANGE_STATE', { argumentType: 1 });
          this.componentId = Argument;
          break;
        case 'voucher':
          this.componentId = Voucher;
          break;
        case 'kf':
          this.$emit('activeTab','kf');
          break;
        default:
          break;
      }
      this.componentShow = true;
    },
    showActivity() {
      const { device_info, appkey, user_id } = this.userState;
      eventTrack({
        appkey: appkey,
        event: 'PLAN_BANNER',
        device_id: device_info.device_id,
        os: device_info.os,
        user_id: user_id,
      });

      this.$store.dispatch('activity/getActivityInfo');
      this.$store.commit('suspend/CHANGE_STATE', { summaryVisible: true, sideBarVisible: false });
    },
    bindPhone() {
      this.mainShow = false;
      this.componentId = BindPhone;
    },
    redirectBoxAdPage() {
      if (this.gameType === 'wxBoxGame') {
        skipWXBox2Sdk({
          event: 'boxAnyPage',
          syAppkey: '',
          boxUrl: wxBoxDownloadUrl(),
          routePath: this.boxAdBanner.router,
        });
      } else {
        boxSkipAnyPage2Sdk({
          boxUrl: boxDownloadUrl(),
          routePath: this.boxAdBanner.router,
        });
      }
    },
    async handleAdClick(item, isBanner) {
      if (!isBanner) {
        await this.handleAdVaild(item, 1)
        buryReportV2('SDK_ADV_POSITION', {
          "advertisement_id": item.id,
          type: item.type,
          router: item.router,
          router_name: item.router_name,
        })
      }
      const gameUrl = await generActLink(item.router)
      if (item.type == 4) {
        const tabs = this.$store.state.suspend.tabs;
        this.$store.commit('suspend/CHANGE_STATE', { activeTab: tabs.find(item => item.type == 'welfare') });
      } else if (redirBoxNewVersion()) {
        // 安卓原生4.4.0以上支持，安卓h5 4.5.4以上支持
        sendSyDiyIntent({
          appKey: this.appkey,
          boxConfig: {
            boxDownloadUrl: item.type == 1  ? wxBoxDownloadUrl() : boxDownloadUrl(),
            boxName: item.type == 1  ? '玩心手游' : '变态猫游戏',
            packageName: item.type == 1  ? 'com.hzwx.wx.box' : 'com.hzwx.bt.box',
          },
          url: gameUrl
        });
      } else {
        gameOpenDownloads({
          gameUrl: gameUrl
        })
        this.boxDownloadType = item.type == 1 ? 'wx' : 'bt';
        this.currentAdId = item.id;
        this.$store.commit('suspend/CHANGE_STATE', { boxDownLoadShow: true })
      }
    },
    async handleBannerClick(item, index) {
      console.log(item)
      await this.handleAdVaild(item, 2)
      buryReportV2('SDK_PERSONAL_BANNER', {
          "banner_id": item.id,
          index: index,
          type: item.type,
          sum_id: item.activity_sum_id,
          sum_name: item.activity_sum_name,
        })
      if (item.type == 1 || item.type == 2) {
        // 1.跳转玩心盒子 2.跳转bt盒子
        this.handleAdClick(item, true);
      } else if (item.type == 3) {
        // 3.打开活动计划弹框
        this.showActivity()
      } else if (item.type == 4) {
        const tabs = this.$store.state.suspend.tabs;
        this.$store.commit('suspend/CHANGE_STATE', { activeTab: tabs.find(item => item.type == 'welfare') });
      }
    },
    async handleAdVaild(item, type) {
      let params = {
        valid_type: type,
        type: item.type,
        image: item.entrance_icon || item.banner,
        id: item.id,
        sort: item.sort,
        appkey: this.appkey,
        show_time_begin: item.show_time_begin || '',
        show_time_end: item.show_time_end || '' 
      }
      if (params.type == 3) {
        params.activity_templet_id = item.activity_templet_id || ''
      } else {
        params.router = item.router || ''
      }
      await boxBannerValid(params)
    },
    handleCloseBoxDownload() {
      buryReportV2('SDK_JUMP_BOX_CLOSE', {
        "advertisement_id": this.currentAdId
      })
      this.$store.commit('suspend/CHANGE_STATE', { boxDownLoadShow: false })
    },
    async getVoucher() {
      const r = await this.$store.dispatch('suspend/getVoucherList');
      this.voucherShow = r.length;
      const voucherIds = this.$getStorage('voucherIds') || [];
      let flag = false;
      r.map(item => {
        if (!voucherIds.includes(item.id)) {
          flag = true;
        }
      })
      this.voucherHint = flag;
    }
  },
};
</script>

<style lang="scss" module>
@import '../common.scss';

.personal {
  position: relative;
  width: 349px;
  background: #ffffff;
  overflow-y: auto;
  @media screen and (orientation: portrait) {
    width: 100%;
  }
  .main {
    height: 100%;
    .close {
      width: 10px;
      height: 10px;
      position: absolute;
      top: 0px;
      right: 0px;
      padding: 16px 10px 15px 20px;
      box-sizing: content-box;
    }
    .actBack {
      display: block;
      width: 95%;
      margin: auto;
      margin-bottom: 5px;
    }
    .mainContent {
      height: calc(100% - 50px);
      overflow-y: auto;
      padding-bottom: 50px;
    }
    .account {
      padding-top: 20px;
      margin: 0px 10px 0;
      color: #7a7979;
      text-align: center;
      font-size: 9px;
      padding-bottom: 15px;
      border-bottom: 1px solid #ebebeb;
    }
    .asSeat {
      display: flex;
      margin: 10px 10px 5px 8px;
      overflow-x: auto;
      > img {
        width: 74px;
        height: 59px;
      }
    }
    .cell {
      padding: 10px 7px {
        right: 15px;
      }
      color: #7a7979;
      font-size: 10px;
      border-bottom: 1px solid #ebebeb;
      margin: 0 10px;
      position: relative;
      display: flex;
      justify-content: space-between;
      > span {
        position: relative;
        &.hint {
          &:before {
            position: absolute;
            content: ' ';
            top: -2px;
            right: -8px;
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: #da3c22;
          }
        }
        &.red {
          color: #da3c22;
        }
      }
      &:after {
        position: absolute;
        content: ' ';
        background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/mine/xiangyou.png') no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 6px;
        bottom: 0;
        margin: auto;
        width: 4px;
        height: 8px;
      }
    }
  }
  .component {
    z-index: 300!important;
  }
}
</style>
